import type { SVGProps } from 'react';

/** Netherlands — horizontal red/white/blue tricolour. Decorative (`aria-hidden`); see `GbFlag` for sizing/crop notes. */
export const NlFlag = ({ width = '17', height = '12', ...props }: SVGProps<SVGSVGElement>) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 60 30"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        {...props}>
        <rect width="60" height="10" fill="#AE1C28" />
        <rect y="10" width="60" height="10" fill="#fff" />
        <rect y="20" width="60" height="10" fill="#21468B" />
    </svg>
);
